var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 13,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#146EF5",
    fillRule: "evenodd",
    d: "m20.738 0-6.617 13H7.906l2.769-5.388h-.125C8.265 10.593 4.857 12.555 0 13V7.687s3.107-.185 4.933-2.115H.001V0h5.545v4.583h.124L7.936 0h4.193v4.555h.125L14.605 0h6.133Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo09);
export default __webpack_public_path__ + "static/media/logo-09.61c2e69b5dfd8aa9ddfc60a1e3d25f23.svg";
export { ForwardRef as ReactComponent };